import { date, money } from "../../../utils/format";

export function TripDatesSidebar({ view, selectedDateIndex, onSelectDate }) {
  return (
    <aside>
      <div className="card">
        <div className="card-header"><h3 className="card-title">Dates et stocks</h3></div>
        <div className="card-body" style={{ display: "grid", gap: 10 }}>
          {view.dates.map((d, index) => {
            const isActive = index === selectedDateIndex;
            return (
              <div
                key={d.id}
                onClick={() => onSelectDate(index)}
                data-testid={`trip-date-${index}`}
                style={{
                  border: `1px solid ${isActive ? "var(--primary)" : "var(--border)"}`,
                  background: isActive ? "var(--primary-50)" : "var(--surface)",
                  borderRadius: "var(--radius)",
                  padding: 12,
                  cursor: "pointer",
                  position: "relative",
                }}
              >
                {d.isCheapestDate ? (
                  <span className="badge success" style={{ position: "absolute", top: -10, right: 10 }}>
                    Meilleur prix
                  </span>
                ) : null}

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                  <div>
                    <div className="strong" style={{ fontSize: 13.5 }}>
                      {date(d.startDate)} — {date(d.endDate)}
                    </div>
                    <div className="muted" style={{ fontSize: 11.5 }}>{d.nbDays} jour{d.nbDays > 1 ? "s" : ""}</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div className="mono strong">{money(d.adultPrice)}</div>
                    <div className="muted" style={{ fontSize: 11 }}>Prix adulte</div>
                  </div>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginTop: 10 }}>
                  <div>
                    <div className="muted" style={{ fontSize: 11 }}>Enfant</div>
                    <div className="strong" style={{ fontSize: 12.5 }}>{money(d.childPrice)}</div>
                  </div>
                  <div>
                    <div className="muted" style={{ fontSize: 11 }}>Bébé</div>
                    <div className="strong" style={{ fontSize: 12.5 }}>{money(d.babyPrice)}</div>
                  </div>
                  <div>
                    <div className="muted" style={{ fontSize: 11 }}>Stock</div>
                    <div className="strong" style={{ fontSize: 12.5 }}>{d.stock}</div>
                  </div>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 10 }}>
                  <span className="agent-avatar" style={{ width: 22, height: 22, fontSize: 10 }}>
                    {(d.manager || "?").charAt(0).toUpperCase()}
                  </span>
                  <span className="muted" style={{ fontSize: 12 }}>{d.manager}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div style={{ height: 16 }}></div>

      <div className="card">
        <div className="card-body" style={{ display: "flex", gap: 16 }}>
          <div>
            <div className="k">Enfants max</div>
            <div className="v">{view.childsMaxAge} ans</div>
          </div>
          <div>
            <div className="k">Bébés max</div>
            <div className="v">{view.babiesMaxAge} ans</div>
          </div>
        </div>
      </div>
    </aside>
  );
}

export default TripDatesSidebar;
